<template>
<div :class="classes" @mouseover="isHover = true;" @mouseleave="isHover = false">

    <p :class="textClasses" v-if="isHover || infoActive">
        Attenzione, la funzionalità implementata in questa pagina chiude tutte le linee attive,
        utilizzare solo in caso di emergenza.
    </p>
    <svg v-else height="40" viewBox="0 0 24 24" width="40">
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path stroke="none" fill="white" d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" /></svg>
</div>
</template>

<script>
export default {
    props: ['infoActive'],
    data: () => {
        return {
            isHover: false
        }
    },
    computed: {
        classes() {
            return this.infoActive ? ['info', 'info-active'] : ['info']
        },
        textClasses() {
            return this.infoActive || this.isHover ? ['text', 'text-active'] : ['text']
        }
    }
}
</script>

<style lang="scss" scoped>
.info {
    position: absolute;
    display: flex;
    border-radius: 50%;
    border: 1px solid grey;
    height: 70px;
    width: 70px;
    justify-content: center;
    top: 20px;
    right: 20px;
    background-color: #C5281C;
    cursor: pointer;
    color: white;
    transition: border-radius 0.5s, width 0.5s, height 0.5s;
    text-align: left;
    font-family: Arial;
    font-style: italic;


    &-active,
    &:hover {
        border-radius: 10px;
        width: 400px;
        padding: 20px;
        height: 100px;
    }
}

svg {
    margin-top: 14px
}

.text {
    font-weight: 500;
    opacity: 0;
    transition: opacity 1s ease-in-out;

    &-active, &:hover{
        opacity: 1;
    }
}

@media screen and (max-width: 600px) {

    .info:hover,
    .info-active {
        border-radius: 10px;
        width: 90%;
        padding: 0;
        text-align: center;
        align-items: center;
    }
}
</style>
